/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
import React from 'react'
import styles from './styles.css'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import gql from 'graphql-tag'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import PropTypes from 'prop-types'
import Script from 'react-load-script'
import Button from 'orionsoft-parts/lib/components/Button'
import { Form, Field } from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import Spinner from 'react-icons/lib/fa/spinner'

@withGraphQL(gql`
  query createPackPayment($packId: ID!) {
    createPackPayment(packId: $packId) {
        _id
        name
        price
        simpleSignatures
        advancedSignatures
        paymentData
    }
  }
`)
@withMutation(gql`
  mutation validationCode($packId: ID, $name: String) {
    validationCode(packId: $packId, name: $name){
      signature{
        paymentData
      }
      code{
        name
        amountDiscount
      }
    }
  }
`)

@withMessage
export default class PackPayment extends React.Component {

  static propTypes = {
    createPackPayment: PropTypes.object,
    validationCode: PropTypes.func,
    codeValidation: PropTypes.object,
    isLoading: PropTypes.bool
  }
  state = {
    cargado: true,
    loadValidation: true,
    isLoading: false,
    isConfirmed: false,
    isError: false
  }

  checkCodeDiscount() {
    return !this.state.discount
  }

  checkValidationCode() {
    return !this.state.loadValidation
  }

  @autobind
  async confirmCodeDiscount() {
    let nameDiscount = this.state.discount.trim()
    let idPack = this.props.variables.packId
    let price = this.props.createPackPayment.price

    this.setState({loadValidation: false})
    this.setState({isLoading: true})
    this.setState({isConfirmed: false})
    this.setState({isError: false})
    try {
      const codeValidation = await this.props.validationCode({packId: idPack, name: nameDiscount})
      this.setState({codeValidation: codeValidation.validationCode})
      let answerCodeValidation = this.state.codeValidation
      const selectName = answerCodeValidation.code.name.findIndex(n => n === nameDiscount)
      if (nameDiscount === answerCodeValidation.code.name[selectName]) {
        const totalDiscount = price * answerCodeValidation.code.amountDiscount
        this.setState({priceCoupon: totalDiscount})
        this.setState({isLoading: false})
        this.setState({isConfirmed: true})
        return this.setState({loadValidation: true})
      }
    } catch (error) {
      this.setState({isLoading: false})
      this.setState({isError: true})
      return this.setState({loadValidation: true})
    }
  }

  renderCodeDiscount() {
    return (
      <Form
        state={this.state}
        onChange={changes => this.setState(changes)}
      >
        <div className='row'>
          <div className='col-xs-4'>
            <Field
              fieldName="discount"
              placeholder="Cupón de descuento"
              type={Text}
            />
          </div>
          <div className='col-xs-8'>
            <div className='row'>
              <Button
                disabled={this.checkCodeDiscount()}
                onClick={() => this.confirmCodeDiscount()}
              >{this.state.isLoading ? (<div className='spinner'>
                  <Spinner/>
                </div>
                ) : (
                  'Aplicar Descuento'
                )}
              </Button>
              <div className='msg'>
                {this.state.isConfirmed && <div className="message">Cupón válido</div>}
                {this.state.isError && <div className="errorMessage">No aplica el cupón</div>}
              </div>
            </div>
          </div>
        </div>
      </Form>
    )
  }

  initProcesoPago() {
    // Cambiar estado depayment a INIT
    if (this.state.codeValidation) {
      return window.location.href = this.state.codeValidation.signature.paymentData.init_point
    }
    return window.location.href = this.props.createPackPayment.paymentData.init_point
  }

  renderInfoPagoPack() {
    const priceDiscount = this.state.priceCoupon
    if (this.state.cargado) {
      return (
        <div className="content">
          <div className="row">
            <div className="col-xs-12 col-sm-6">Nombre de plan:</div>
            <div className="col-xs-12 col-sm-6"> { this.props.createPackPayment.name } </div>
          </div>
          {!!priceDiscount
            ? <div className="row">
              <div className="col-xs-12 col-sm-6">Precio de plan:</div>
              <div className="col-xs-12 col-sm-6 txtPrice"> { this.formatCurrency(this.props.createPackPayment.price) } </div>
            </div>
            : <div className="row">
              <div className="col-xs-12 col-sm-6">Precio de plan:</div>
              <div className="col-xs-12 col-sm-6"> { this.formatCurrency(this.props.createPackPayment.price) } </div>
            </div>}
          {!!priceDiscount
            ? <div className="row">
              <div className="col-xs-12 col-sm-6">Precio de plan con descuento:</div>
              <div className="col-xs-12 col-sm-6"> { this.formatCurrency(this.props.createPackPayment.price - priceDiscount) } </div>
            </div>
            : null}
          <div className="row">
            <div className="col-xs-12 col-sm-6">Firmas Simples:</div>
            <div className="col-xs-12 col-sm-6"> { this.props.createPackPayment.simpleSignatures } </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6">Firmas Avanzados:</div>
            <div className="col-xs-12 col-sm-6"> { this.props.createPackPayment.advancedSignatures } </div>
          </div>
          <div>
            {this.props.getCodeDiscount ? this.renderCodeDiscount() : this.renderCodeDiscount()}
          </div>
          <p><b>
                * Al hacer click en "Pagar Acá" será direccionado a MercadoPagos, terminado el proceso NO cierre la ventana, pues
                será redirigido automáticamente a tufirma.digital
          </b>
          </p>

          <Button primary
            disabled = {this.checkValidationCode()}
            onClick={ () => this.initProcesoPago() }
          >Pagar acá</Button>
        </div>
      )
    }
  }

  formatCurrency(amount, decimalCount = 0, decimal = ',', thousands = '.') {
    try {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount

      const negativeSign = amount < 0 ? '-' : ''

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString()
      let j = (i.length > 3) ? i.length % 3 : 0

      return ' $' + negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
    } catch (e) {
      console.log(e)
    }
  };

  renderBtnPago() {
    let attData = {
      'data-preference-id': this.props.createPackPayment.paymentData.paymentId,
      'data-button-label': 'Comprar Pack de Firmas'
    }
    return (
      <form method="POST" className="btnPago">
        <Script
          url="https://www.mercadopago.cl/integrations/v1/web-payment-checkout.js"
          attributes={ attData }
          onLoad={this.handleScriptLoad.bind(this)}
        />
      </form>
    )
  }

  handleScriptLoad() {
    this.setState({cargado: true})
  }

  renderPage() {
    if (this.state.cargado) {
      return (
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Confirmar Compra Pack de Firmas</h3>
          </div>
          {this.renderInfoPagoPack()}
          <div/>
        </div>
      )
    }
  }

  render() {
    if (this.props.createPackPayment) {
      return (
        <div className={styles.container}>
          {this.renderPage()}
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Payments/PackPayment/index.js